/** Allocation bills /metering/bill/split-bill (splittheBill.vue) */
export default {
  splitBillPage: {
    phDateStart: 'Start date',
    phDateEnd: 'End date',
    phShareGroup: 'Share group',
    phShareType: 'Share type',
    shareTypeElec: 'Electricity share',
    shareTypeWater: 'Water share',
    shareTypeShort: 'Share',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    sectionTitle: 'Allocation bills',
    sortDefault: 'Default sort',
    selectedLine: '<span class="count">{count}</span> row(s) selected',
    colRid: 'Settlement ID',
    colOccurDate: 'Settlement date',
    colShareId: 'Group ID',
    colShareName: 'Group name',
    colShareType: 'Share type',
    colBalance: 'Total amount',
    colTotalArea: 'Total shared area',
    colSettleStatus: 'Status',
    colAction: 'Actions',
    btnDetail: 'Details',
    drawerTitleAll: 'Share settlement details',
    drawerTitleElec: 'Electricity share settlement',
    drawerTitleWater: 'Water share settlement',
    descSettleId: 'Settlement ID',
    descSettleDate: 'Settlement date',
    descShareGroupId: 'Group ID',
    descShareGroupName: 'Group name',
    descTotalAmount: 'Total amount',
    descTotalArea: 'Total shared area',
    descSettleStatus: 'Status',
    dividerDetail: 'Allocation lines',
    colDeviceId: 'Device ID',
    colDeviceName: 'Device name',
    colBindType: 'Type',
    colUseKwh: 'Energy (kWh)',
    colAlarm: 'Warning',
    colTenant: 'Tenant',
    tenantIdPrefix: 'ID:',
    colShareBalance: 'Allocated (¥)',
    colSharePercent: 'Share %',
    colSumUse: 'Total use (kWh)',
    colArea: 'Usable area (m²)',
    colDefaultPublicArea: 'Default shared area (m²)',
    emptyNoDetail: 'No allocation lines',
    status0: 'Unsettled',
    status1: 'Settled',
    status2: 'In progress',
    status3: 'Failed',
    statusUnknown: 'Unknown',
    deviceTypeDedicated: 'Dedicated meter',
    deviceTypeShare: 'Share group',
    deviceTypeDash: '-',
    msgShareListFail: 'Failed to load share groups',
    msgFetchFail: 'Failed to load bills',
    msgMissingFeeId: 'Missing bill ID',
    msgDetailFail: 'Failed to load details',
    msgNoDataExport: 'No data to export',
    msgExportOk: 'Exported {count} row(s).',
    msgExportOkSelected: 'Exported {count} selected row(s).',
    msgExportFail: 'Export failed. Please try again.',
    exportSheetName: 'Share bills',
    filePrefixAll: 'ShareBill',
    filePrefixElec: 'ElecShareBill',
    filePrefixWater: 'WaterShareBill',
    unitSqm: ' m²',
    // Export (current page / selected / all) unified copy
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    warnNoSelectedExport: 'Please select rows to export first',
    successExported: 'Exported {count} row(s).',
    successExportedLimit: '{total} matched, up to {count} per export, first {count} exported',
    exporting: 'Exporting all data...'
  }
}
